import { captureMessage, captureException, isInitialized } from '@sentry/react'
import { CheckInternet } from 'shared/store/CheckInternet'

export type ISentrySentEventProps = {
  event: string
  level: 'fatal' | 'error' | 'warning' | 'log' | 'debug' | 'info'
  error?: Error | unknown
  name: string
  tags?: {
    [key in string]: number | string | boolean | bigint | symbol | null | undefined
  }
  fingerprint?: string[]
  extra?: Record<string, unknown>
}

export const sentEventSentry = ({
  event,
  error,
  level,
  name,
  tags,
  fingerprint,
  extra,
}: ISentrySentEventProps) => {
  if (!isInitialized()) return null

  if (error instanceof Error) {
    error.name = event ? `${event}: ${error.name}` : error.name

    captureException(error, {
      level: 'error',
      tags: {
        'app.service': name,
        enableInternet: CheckInternet.isOnline,
        ...tags,
      },
      fingerprint: fingerprint,
      extra: extra,
    })
  } else {
    captureMessage(event, {
      level: level,
      tags: {
        'app.service': name,
        enableInternet: CheckInternet.isOnline,
        ...tags,
      },
      fingerprint: fingerprint,
      extra: extra,
    })
  }
}
